<template>
  <div v-if="customerPortalToken && merchantSettings">
    <div class="rush-overlay d-flex align-items-center justify-content-center">
      <div
        class="loader-container d-inline-flex align-items-center justify-content-center"
      >
        <div class="spinner position-absolute"></div>
        <img
          class="logo position-absolute"
          src="@/assets/images/rush-brand_mark.png"
          width="100px"
          alt="RUSH"
        />
        <div class="orange-overlay" :style="cssStyle"></div>
      </div>
    </div>
    <template v-if="isFullScreen">
      <router-view />
    </template>
    <template v-else>
      <Navbar />
      <transition name="component-fade" mode="out-in">
        <router-view />
      </transition>
      <Footer />
    </template>
  </div>
</template>

<script>
import Navbar from "@/components/layout/Navbar.vue";
import Footer from "@/components/layout/Footer.vue";
import $ from "jquery";
import { mapState } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState("estore", ["isFullScreen", "webDesign"]),
    ...mapState("merchant", ["customerPortalToken", "merchantSettings"]),
    cssStyle: {
      get() {
        return {
          "--main-color":
            this.webDesign && this.webDesign.design
              ? this.webDesign.design.main_color
              : "#fff"
        };
      },
      set(style) {
        return style;
      }
    }
  },
  components: {
    Navbar,
    Footer
  },
  mounted() {
    function removeLoader() {
      $(".orange-overlay").addClass("display-me");
      $(".rush-overlay").fadeOut(1500, function() {
        $(".rush-overlay").remove();
      });
    }

    this.$nextTick(() => {
      setTimeout(removeLoader, 1000);
    });
  }
};
</script>

<style lang="scss" scoped>
.rush-overlay {
  height: 100%;
  width: 100%;
  position: fixed; /* Stay in place */
  z-index: 9999 !important; /* Sit on top */
  left: 0;
  top: 0;
  background: white;

  .loader-container {
    .spinner {
      border: 5px solid #e5e5e5;
      border-radius: 50%;
      border-top: 5px solid #fff;
      width: 140px;
      height: 140px;
      -webkit-animation: spin 2s linear infinite; /* Safari */
      animation: spin 2s linear infinite;
    }
    .orange-overlay {
      display: none;
      background: var(--main-color);
      border-radius: 50%;
      width: 140px;
      height: 140px;
      animation: orange 2s ease;
    }
    .display-me {
      display: block !important;
    }

    /* Safari */
    @-webkit-keyframes spin {
      0% {
        -webkit-transform: rotate(0deg);
      }
      100% {
        -webkit-transform: rotate(360deg);
      }
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
    /* Safari */
    @-webkit-keyframes orange {
      0% {
        -webkit-transform: scale(1);
      }
      100% {
        -webkit-transform: scale(100);
      }
    }

    @keyframes orange {
      0% {
        transform: scale(1);
      }
      100% {
        transform: scale(100);
      }
    }
  }
}
</style>
